import type { ComponentPropsWithoutRef } from 'react'
import { coorumColors } from '../../survey/coorumTheme'

type Props = ComponentPropsWithoutRef<'svg'>

// @see survey-library loading svg
export function LoadingIcon(props?: Props) {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_885_24957)">
        <path opacity="0.1" d="M24 40C15.18 40 8 32.82 8 24C8 15.18 15.18 8 24 8C32.82 8 40 15.18 40 24C40 32.82 32.82 40 24 40ZM24 12C17.38 12 12 17.38 12 24C12 30.62 17.38 36 24 36C30.62 36 36 30.62 36 24C36 17.38 30.62 12 24 12Z" fill="black" fillOpacity="0.91" />
        <path d="M10 26C8.9 26 8 25.1 8 24C8 15.18 15.18 8 24 8C25.1 8 26 8.9 26 10C26 11.1 25.1 12 24 12C17.38 12 12 17.38 12 24C12 25.1 11.1 26 10 26Z" fill={props?.fill ?? coorumColors.mainColor} />
      </g>
      <defs>
        <clipPath id="clip0_885_24957">
          <rect width="32" height="32" fill="white" transform="translate(8 8)" />
        </clipPath>
      </defs>
    </svg>
  )
}
